import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { UniversalBoxes } from "@pages/home/components/UniversalBoxes";

export const SelfSellingSection = () => {
  return (
    <div className="bg-white p-4 font-sans">
      {/* Section 1 */}
      <section className="bg-gray-50 px-8 py-16 text-center">
        <h1 className="mb-4 text-3xl font-bold text-gray-800">
          Líder em Soluções Inovadoras
        </h1>
        <p className="mx-auto mb-6 max-w-3xl text-justify text-gray-600">
          Na Restart Design & Consulting, oferecemos tecnologias avançadas e
          serviços personalizados para otimizar sua operação no setor de Óleo &
          Gás. Nossos produtos, como válvulas industriais subsea e sistemas de
          automação de última geração, são projetados para maximizar a
          eficiência e segurança, minimizando impactos ambientais.
          <br />
          <br />
          Com uma abordagem focada na inovação e sustentabilidade, garantimos
          soluções confiáveis que atendem às suas necessidades operacionais e
          estratégicas.
        </p>
        <div className="flex w-full items-center justify-center">
          <a
            href="/contact-us"
            className="flex items-center gap-3 rounded-sm bg-primary-700 px-6 py-3 font-medium text-white transition-all hover:bg-primary-800"
          >
            Solicitar Demonstração
            <FontAwesomeIcon icon={faArrowRight} />
          </a>
        </div>
      </section>

      {/* Section 2 */}
      <section className="px-8 py-16">
        <h2 className="mb-8 text-center text-2xl font-bold text-gray-800">
          Descubra alguns de nossos produtos e soluções
        </h2>
        <p className="mx-auto mb-12 max-w-2xl text-center text-gray-600">
          Explore as soluções líderes em tecnologia para o setor de Óleo & Gás.
          Nossos produtos incluem válvulas industriais de alta performance,
          sistemas de automação avançados e equipamentos subaquáticos projetados
          para garantir eficiência e segurança em todas as operações.
        </p>

        <UniversalBoxes />
      </section>
    </div>
  );
};
